export default __webpack_public_path__ + "static/media/video-thumb.940ec5d0.png";